import React from "react";
import { Modal } from "antd";

import "../../../styles/bulletinAdmin/components/confirmDelete.scss";

export default function ConfirmDeleteModal({
  type = "item",
  open,
  onConfirm,
  onCancel,
  confirmLoading = false,
}) {
  return (
    <Modal
      className="confirm-delete-modal"
      title="Confirm Deletion"
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
      okText="Delete"
      okType="text"
    >
      Are you sure you want to delete this <strong>{type}</strong>? This action
      cannot be undone.
    </Modal>
  );
}
